import {
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFeCode from "./NFe.Code";
import { getLabel } from "src/hook/Functions";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";
import moment from "moment";
import "./Styles.css";
import NFeModalPropriedadesView from "./Modal.Propriedades/NFe.Modal.Propriedades.View";
import NFeModalNovoView from "./Modal.Novo/NFe.Modal.Novo.View";
import { statusEnvioOptions } from "../NFCe/NFCe.Dto";

const NFeView = () => {
  const code = NFeCode();

  return (
    <>
      <Container>
        <HeadPage headText="NFe" onToggle={code.menu.handleMenuToggleClick}>
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={code.handleChangeSerie}
                      value={
                        code.useFilter.filters.serie &&
                        code.useFilter.filters.serie > 0
                          ? code.useFilter.filters.serie.toString()
                          : ""
                      }
                    />
                    <NavDropdown
                      onSelect={code.handleSelectStatus}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioOptions,
                        code.useFilter.filters.codigoStatusEnvio,
                        "Status Envio"
                      )}
                    >
                      {statusEnvioOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={
                            code.useFilter.filters.codigoStatusEnvio ===
                            option.value
                          }
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={code.useFilter.filters.dataEmissaoInicial}
                      onChange={code.handleSetDates}
                      startDate={code.useFilter.filters.dataEmissaoInicial}
                      endDate={code.useFilter.filters.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={code.getDatePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
            <Table responsive hover className="mt-2 no-border">
              <tbody>
                {code.data.map((item) => (
                  <tr
                    key={item.id}
                    style={{ cursor: "pointer" }}
                    onClick={code.handleClickPropriedades(item)}
                  >
                    <td colSpan={5} className="p-0">
                      <div className="border rounded p-2 mb-2">
                        <div className="d-flex align-items-center flex-wrap">
                          <div className="flex-grow-0 me-3 fw-bold">
                            NF: {item.numeroNF}
                          </div>

                          <div className="flex-grow-0 me-3">
                            Série: {item.serie}
                          </div>

                          <div className="flex-grow-1 text-truncate me-3">
                            Sefaz: {item.autorizacao.codigoStatusEnvio}-
                            {item.autorizacao.descricaoStatusEnvio}
                          </div>

                          <div className="flex-grow-1 text-truncate d-none d-md-block me-3">
                            {item.autorizacao.codigoStatusResposta}-
                            {item.autorizacao.descricaoMotivoResposta}
                          </div>

                          <div className="ms-auto text-end">
                            Emissão:{" "}
                            {moment(item.emissaoDataHora).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </div>

                          {/* “quebra de linha” */}
                          <div className="w-100 my-1"></div>

                          <div className="flex-grow-1">
                            <small className="text-muted">Destinatário</small>
                            <div className="text-muted">
                              {item.destinatario?.nome}
                            </div>
                          </div>

                          <div className="text-end">
                            <small className="text-muted">Total</small>
                            <div className="text-muted">
                              R$ {item.total?.valorNotaFiscal?.toFixed(2)}
                            </div>
                          </div>

                          <div className="w-100"></div>

                          <div className="flex-grow-1">
                            <small className="text-muted">Documento</small>
                            <div className="text-muted">
                              {item.destinatario?.documento}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>

      <NFeModalPropriedadesView
        show={code.modalShowPropriedades}
        nfe={code.nfe}
        onReturn={code.onReturnModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
        onPrint={code.onPrintModalPropriedades}
        onDownloadXml={code.onDownloadXml}
        onFetchStatus={code.onFetchStatusModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onEdit={code.onEditModalPropriedades}
        onDuplicate={code.onDuplicateModalPropriedades}
        onEvent={code.onEventModalPropriedades}
      />

      <NFeModalNovoView
        show={code.modalNovoShow}
        onContinuar={code.onContinuarModalNovo}
        onCriarNovo={code.onCriarNovoModalNovo}
        onCancel={code.onCancelModalNovo}
      />
    </>
  );
};
export default NFeView;
